import { Link, To } from 'react-router-dom'
import { Button } from './Button'
import type { ButtonProps } from './Button'

type Props = { to: To } & ButtonProps

export const LinkButton = ({ to, ...props }: Props) => {
    return (
        <Link to={to}>
            <Button {...props} />
        </Link>
    )
}
